import delay from '@redux-saga/delay-p';
import { computeErrorCode } from 'affiny-core/helpers/errors';
import { toasterService } from 'affiny-core/services/toaster/toaster';
import { all, call, cancel, fork, put, spawn } from 'redux-saga/effects';
import { IFormattedApiError } from '../api/core/types';
import { asyncStateActions } from './actions';
import { EAsyncEventTypes } from './types';

export function* addDelayToLoaderSaga(
  asyncEventName: EAsyncEventTypes,
  shouldDelayLoader: boolean
) {
  if (shouldDelayLoader) {
    yield call(delay, 300);
  }

  yield put(asyncStateActions.showLoader(asyncEventName));
}

export const handleAsyncStatus = (
  saga: any,
  asyncEventName: EAsyncEventTypes,
  shouldDelayLoader = false,
  minLoaderDuration = 0,
  sagaParams?: any
) =>
  function* (...args: any[]): any {
    const task = yield fork(
      addDelayToLoaderSaga,
      asyncEventName,
      shouldDelayLoader && !minLoaderDuration
    );
    const extendedParams = sagaParams ? [...args, sagaParams] : args;

    try {
      const [result] = yield all([
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore https://github.com/Microsoft/TypeScript/issues/4130
        call(saga, ...extendedParams),
        call(delay, minLoaderDuration),
      ]);

      yield put(asyncStateActions.removeError(asyncEventName));

      return result;
    } catch (error) {
      yield put(asyncStateActions.addError(asyncEventName, error));
      yield spawn(showToasterSaga, asyncEventName, error);
    } finally {
      yield cancel(task);
      yield put(asyncStateActions.hideLoader(asyncEventName));
    }
  };

export function* showToasterSaga(
  asyncEventName: EAsyncEventTypes,
  error: IFormattedApiError
) {
  const computedErrorCode = computeErrorCode(error, asyncEventName);

  if (computedErrorCode) {
    yield call([toasterService, 'show'], `errors.${computedErrorCode}`);
  }
}
